const marketplaceConfig = {
  marketplaceName: 'FoodLoop',
  marketplaceDescription: 'FoodLoop is a marketplace for buying and selling food items.',
  marketplaceUrl: 'https://foodloop.orders.co',
  logoUrl: 'https://ik.imagekit.io/9k7yic5f8qm/logo/FoodLoop-Logo_Gqa-qL6bm.png?updatedAt=1730723876093',
  squareLogoUrl: 'https://ik.imagekit.io/9k7yic5f8qm/logo/foodloopAppIcon_nfkoycCki.svg?updatedAt=1730734548545',
  supportEmail: 'info@tryfoodloop.com',
  supportPhone: '+1 123 456 7890',
  supportQrUrl: null,
  supportUrl: 'https://foodloop.orders.co/support',
  termsUrl: 'https://foodloop.orders.co/terms',
  privacyUrl: 'https://foodloop.orders.co/privacy',
  aboutUrl: 'https://foodloop.orders.co/about',
  faqUrl: 'https://foodloop.orders.co/faq',

  socialLinks: {
    facebook: 'https://www.facebook.com/foodloop',
    twitter: 'https://twitter.com/foodloop',
    instagram: 'https://www.instagram.com/foodloop',
    linkedin: 'https://www.linkedin.com/company/foodloop',
  },
  address: {
    street: '123 Main St',
    city: 'San Francisco',
    state: 'CA',
    zip: '94111',
    country: 'USA',
  },
  mobileAppInfo: {
    iosAppUrl: 'https://apps.apple.com/us/app/foodloop/id1234567890',
    androidAppUrl: 'https://play.google.com/store/apps/details?id=com.foodloop',
    enabled: false,
  },
};
export default marketplaceConfig;
